<template>
    <div class="tab-education">
        <div class="smalltitle">Position and Appointment</div>
        <ul class="itemlist">
            <li v-for="item in positionAndAppointmentData">
                <div class="row">
                    <div class="col-xs-5">{{item.name}}</div><!--Display Max: 45 char-->
                    <div class="col-xs-3">{{item.position}}</div><!--Display Max: 40 char-->
                    <div class="col-xs-2">{{item.years}}</div>
                    <div class="col-xs-2 itemaction">

                    </div>
                </div>
            </li>
        </ul>

    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      positionAndAppointmentData: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getPositionAp()
  },
  beforeDestroy () {
  },
  methods: {
    async getPositionAp () {
      try {
        let response = await httpClient.get('/users/position-appointment/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.positionAndAppointmentData = response.data.data.positions
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
